'use client';
import React from 'react';
import type { FormatTextProps } from '@/utils/text/text';
import { formatText } from '@/utils/text/text';

type RichTextParagraphProps = FormatTextProps & {
    className?: string;
};

export const RichTextParagraph: React.FC<RichTextParagraphProps> = (props) => {
    // TODO: remove dangerouslySetInnerHTML
    return <p className={props.className} dangerouslySetInnerHTML={{ __html: formatText(props) }} />;
};
